<script lang="ts">
	import Alert from '$lib/components/Alert.svelte';

	export let label: string = null;
</script>

<Alert classNames="bg-premium-light text-premium" icon="info" {label}>
	<svelte:fragment slot="header">
		<slot name="header" />
	</svelte:fragment>
	<svelte:fragment slot="body">
		<slot name="body" />
	</svelte:fragment>
</Alert>
